import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageToggle: React.FC = () => {
  const { i18n } = useTranslation();
  const current = i18n.language.startsWith('de') ? 'de' : 'en';

  return (
    <div className="flex items-center gap-2">
      <button
        className={`px-3 py-1 rounded font-bold border-2 border-black ${current === 'en' ? 'bg-black text-white' : 'bg-white text-black'}`}
        onClick={() => i18n.changeLanguage('en')}
        aria-pressed={current === 'en'}
      >
        EN
      </button>
      <button
        className={`px-3 py-1 rounded font-bold border-2 border-black ${current === 'de' ? 'bg-black text-white' : 'bg-white text-black'}`}
        onClick={() => i18n.changeLanguage('de')}
        aria-pressed={current === 'de'}
      >
        DE
      </button>
    </div>
  );
};

export default LanguageToggle; 